var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitterIco(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.1 21.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "twitter_ico"
  }, /*#__PURE__*/React.createElement("g", {
    id: "twitter_ico-2",
    "data-name": "twitter ico"
  }, /*#__PURE__*/React.createElement("path", {
    id: "twitter-large",
    d: "M23.29,3.62s3,.37,3.81-.19a16.82,16.82,0,0,0-3.9,2.79s1.12,12.34-11.79,15.31c0,0-6.67.56-11.41-3.06,0,0,5.11,1.39,7.89-1.77,0,0-4.73.47-5.94-3.24a13.88,13.88,0,0,0,3.34-.41S.83,12.15.92,7.7a4.54,4.54,0,0,0,2.51.65S-.28,5,2,1.11c0,0,4.92,6,11,5.66a5.25,5.25,0,0,1,8.81-5A8.34,8.34,0,0,0,25.51,0a5.18,5.18,0,0,1-2.22,3.62Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIco);
export default __webpack_public_path__ + "static/media/twitter_ico.387bf7424618d6619d18e56f0a7e1e94.svg";
export { ForwardRef as ReactComponent };